/**
 * en-GB messages added by Phase 4 task I1 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const i1EnGB = {
    'kiosk.language.choose': 'Choose your language',
    'kiosk.language.button': 'Language',
    'public.language.label': 'Language',
};
//# sourceMappingURL=i1.js.map